const whitePaperListInit = () => {
    const mainPattern = document.querySelectorAll('.gg-banner-case');
    mainPattern.forEach((module) => {
        //Hidden button PDF
        const buttonPDF = module.querySelector('.button-pdf a')
        if(buttonPDF) {
            const linkPDF = buttonPDF.getAttribute('href');
            if (!linkPDF) {
                document.querySelector('.button-pdf').style.display = 'none';
            }
        }
        // Hidden button play video
        const videoPopup = module.querySelector('.gravity-block-external-video');
        if (videoPopup) {
            const videoId = videoPopup.getAttribute('data-video-id');
            if (!videoId) {
                videoPopup.style.display = 'none';
            }
        }
        const imgBlog = module.querySelector('.img-blog')
        if(imgBlog) {
            const imgDefault = imgBlog.querySelector('img');
            const caseStudy = document.querySelector('.single-case-studies')
            if(!imgDefault) {
                const newImg = document.createElement('img');
                newImg.width = 675;
                newImg.height = 513;
                newImg.className = "attachment-medium_large size-medium_large wp-post-image gg-default-image";
                newImg.alt = "";
                if(caseStudy) {
                    newImg.src = "/wp-content/themes/gravity-global-child/assets/images/image-default.jpg";
                }
                else {
                    newImg.src = "/wp-content/themes/gravity-global-child/assets/images/image-blog-default.jpg";
                }
                newImg.sizes = "(max-width: 640px) 100vw, 640px";
                imgBlog.appendChild(newImg);
            }
        }
        const buttonShare = module.querySelector('.gravity-block-share-icons__collapse');
        if (buttonShare) {
            const buttonParent = buttonShare.parentElement;
            const nextElement = buttonShare.nextElementSibling;
            const groupIcon = nextElement.querySelector('.gravity-block-share-icons__list');
            const groupIconParent = groupIcon.parentElement;
            const widthGroup = groupIcon.offsetWidth;
            const copyWidth = buttonShare.parentElement.offsetWidth;
            buttonParent.style.maxWidth = '44px';
            buttonShare.setAttribute('data-click', 'false');
            const siblingButton = buttonParent.nextElementSibling;
            siblingButton.setAttribute('data-hidden', 'false');
            buttonShare.addEventListener('click', (event) => {
                event.stopImmediatePropagation();
                const isClicked = buttonShare.getAttribute('data-click') === 'true';
                if (nextElement) {
                    if (isClicked) {
                        buttonParent.style.maxWidth = '44px';
                        buttonShare.setAttribute('data-click', 'false');
                        siblingButton.setAttribute('data-hidden', 'false');
                    } else {
                        if (window.innerWidth < 768) {
                            
                            buttonParent.style.maxWidth = `${widthGroup + 80 }px`;
                            groupIconParent.style.width = '100%';
                            siblingButton.setAttribute('data-hidden', 'true');
                        } else {
                            nextElement.classList.add('width-collapse');
                            buttonParent.style.maxWidth = `${copyWidth + 5}px`;
                        }
                        buttonShare.setAttribute('data-click', 'true');
                    }
                }
            });
        }
        const redditIcon = module.querySelector('.gravity-block-share-icons__reddit')
        if(redditIcon)
        {
            const svgReddit = redditIcon.querySelector('.gravity-block-share-icons__svg')
            svgReddit.removeAttribute('viewBox');
        }
        const linkBio = module.querySelector('.link_bios');
        if (linkBio) {
            const bioContent = (linkBio.textContent || linkBio.innerText).trim();
            const a = module.querySelector('.gravity-block-share-icons__linkedin');
            if(bioContent == '' || bioContent == null) {
                const linkin = module.querySelector('.gravity-block-share-icons__container');
                linkin.style.display = 'none';
            }
            if (a && bioContent) {
                a.href = bioContent;
            }
        }
    });
  }
whitePaperListInit();